import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js"

export default class extends Controller {
  static values = {
    open: {type: Boolean, default: false},
  }

  initialize() {
    this.openIfNeeded = this.openIfNeeded.bind(this);
    this.loading = false;
  }


  connect() {
    let isRoot = this.element.dataset.root == 'true';
    let hasChildren = this.element.classList.contains('has-children');
    if (!hasChildren || isRoot) {
      // this.disconnect();
      return;
    }

    this.register_event();
  }

  openIfNeeded() {
    if (this.openValue) {
      console.log('trying to open');
      setTimeout(() => this.fetch_subtree(), 300);
    }
  }

  register_event() {
    const account_id = this.element.dataset.id;

    this.eventHandler = (() => {
      this.collapse().then(() => this.open());
    });

    document.addEventListener(`account_subtree:${account_id}:open`, this.eventHandler);
  }

  disconnect() {
    if (this.eventHandler) {
      const account_id = this.element.dataset.id;
      document.removeEventListener(`account_subtree:${account_id}:open`, this.eventHandler);
    }
  }

  async open(event) {
    console.log('OPENING..');
    if (this.loading) return;
    this.loading = true;

    if (this.isOpen) {
      await this.collapse();
      this.loading = false;
    } else {
      setTimeout(() => {
        this.fetch_subtree();
      }, 100);
    }
  }

  fetch_subtree() {
    console.log('fetching subtree..')

    get(this.url)
      .then((response) => {
        return response.html
      })
      .then((response) => {
        console.log('got response');

        this.remove_subtree();
        this.add_subtree(response);
        this.openValue = true;
        this.element.classList.add('open');
        this.loading = false;
      })
  }

  add_subtree(subtree) {
    this.element.insertAdjacentHTML('afterend', subtree)
  }

  async collapse() {
    console.log('Collapsing..');

    // this.element.nextElementSibling.remove();
    // this.element.classList.remove('open');

    this.remove_subtree();
    // console.log('id', id);
    this.openValue = false;
    this.element.classList.remove('open');

    return Promise.resolve();
  }

  remove_subtree() {
    if (this.subtree_element) {
      this.subtree_element.remove();
    }
  }

  get subtree_element() {
    return document.querySelector(`#children_of_account_${this.element.dataset.id}`);
  }

  get isOpen() {
    return this.openValue;
  }

  get url() {
    return this.element.dataset.url;
  }
};
